import(/* webpackMode: "eager", webpackExports: ["App"] */ "__barrel_optimize__?names=App!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["ConfigProvider"] */ "__barrel_optimize__?names=ConfigProvider!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@ant-design/nextjs-registry/es/AntdRegistry.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/nextjs-toploader/dist/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Common/GoToTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Cookie/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Footer/page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Header/Menu/MenuTwo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Header/TopNav/TopNavOne.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/homeComponent/discount2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Mobile/footer-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Modal/ModalCustomer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Modal/ModalInquiry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Other/CustomerBtn.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CategoryProvider"] */ "/app/src/context/CategoriesContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/context/channel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModalCustomerProvider"] */ "/app/src/context/CustomerContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModalInquiryProvider"] */ "/app/src/context/ModalInquiryContext.tsx");
